/**
 * @description SO-host apple-touch-icon policy for ClockRouter. Worker first
 * HTML already stamps /apple-touch-icon.png?v=shareCardVersion. Do not
 * replace that with the bare path (same stomp #401 fixed on the dashboard).
 *
 * @dependencies none
 *
 * @notes shareCardVersion lives in workers/lib/web-identity.cjs — do not
 * invent a third hash here. If the Worker href already has ?v=, keep it.
 * If it does not, leave the tag alone; never write the unversioned URL.
 */

/**
 * True when the existing apple-touch-icon href is the Worker versioned URL.
 *
 * @param {string|null|undefined} href
 * @returns {boolean}
 */
export function keepWorkerAppleTouchHref(href) {
  return typeof href === 'string' && href.includes('?v=');
}

/**
 * On an SO Worker host, do not rewrite apple-touch-icon to the bare path.
 *
 * @param {Document} doc
 * @returns {string|null} href left on the document
 */
export function preserveSoAppleTouchIcon(doc) {
  if (!doc || typeof doc.querySelector !== 'function') return null;
  const link = doc.querySelector("link[rel='apple-touch-icon']");
  if (!link) return null;
  const href = link.getAttribute('href');
  if (keepWorkerAppleTouchHref(href)) return href;
  return href || null;
}
